/* global femcare */

femcare.shared.animation = {
    init: function() {
        this.initStrikethrough();
    },

    initStrikethrough: function() {
        var $strikethroughText = $('.strikethrough');

        if ($strikethroughText.length) {
            var animate = function() {
                var $toAnimate = $strikethroughText.not('.strikethrough--animate');

                $toAnimate.each(function(index, element) {
                    var $element = $(element);

                    if (femcare.shared.util.isElementInViewport($element)) {
                        $element.addClass('strikethrough--animate');
                    }
                });

                if ($toAnimate.length === 0) {
                    $(window).off('wheel scroll resize', animate);
                }
            };

            $(window).on('wheel scroll resize', animate);
            animate();
        }
    }
};
